import axios from 'axios';

export const initDevToolsPrevention = async () => {
  // Check if protection is enabled
  try {
    const response = await axios.get('/public/settings/protection');
    const protectionEnabled = response.data?.inspect_element_protection || false;
    
    if (!protectionEnabled) {
      return;
    }

    // Method 1: Disable right-click globally (silent)
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
      return false;
    });

    // Method 2: Detect and prevent common DevTools shortcuts (silent)
    document.addEventListener('keydown', (e) => {
      // F12
      if (e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+I or Cmd+Option+I (Inspect Element)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+J or Cmd+Option+J (Console)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+Shift+C or Cmd+Option+C (Element Selector)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        return false;
      }
      
      // Ctrl+U or Cmd+U (View Source)
      if ((e.ctrlKey || e.metaKey) && e.keyCode === 85) {
        e.preventDefault();
        return false;
      }
    });

  } catch (error) {
    console.error('Failed to check DevTools protection settings:', error);
  }
};

export default initDevToolsPrevention;
